<template>
  <footer id="footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-6 mb-lg-0">
          <div
            class="text-sm text-center copyright text-muted"
            :class="this.$store.state.isRTL ? 'text-lg-end' : 'text-lg-start'"
          >
            <a
              href="https://huestimates.com/"
              class="font-weight-bold"
              target="_blank"
              >Progress</a
            >
              IMS Agent v.1.0.024
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
};
</script>
<style>
#footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1020;
  padding: 14px 10px;
}

#footer a.font-weight-bold {
  text-decoration: none;
  transition: color 0.2s ease;
}
</style>